exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".device-manager .devices {\n  padding: 20px; }\n  .device-manager .devices .device {\n    margin: 10px 0; }\n    .device-manager .devices .device .remove-device {\n      margin: 0 12px; }\n      .device-manager .devices .device .remove-device:hover {\n        cursor: pointer; }\n\n@media (max-width: 480px) {\n  .device-manager .devices .device .remove-device {\n    margin-right: 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/device_manager/device_manager.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/device_manager/device_manager.scss
// module chunks = index